const menuItems = document.querySelectorAll('.header-menu > li.menu-item-has-children');

new SV.HoverIntent(menuItems, {
    onEnter: function(targetItem) {
        targetItem.classList.add('visible');
        document.body.classList.add('menu-open');
        targetItem.querySelector('.sub-menu-wrapper video')?.play();
    },
    onExit: function(targetItem) {
        targetItem.classList.remove('visible');
        document.body.classList.remove('menu-open');
        targetItem.querySelector('.sub-menu-wrapper video')?.pause();
    },

    exitDelay: 500,
    interval: 100,
    sensitivity: 7,
});

menuItems.forEach(item => {
    item.addEventListener('focusin', () => {
        menuItems.forEach(other => {
            if (other !== item) {
                other.classList.remove('visible');
                other.querySelector('.sub-menu-wrapper video')?.pause();
            }
        });
        item.classList.add('visible');
        document.body.classList.add('menu-open');
        item.querySelector('.sub-menu-wrapper video')?.play();
    });

    item.addEventListener('focusout', e => {
        if (!item.contains(e.relatedTarget)) {
            item.classList.remove('visible');
            document.body.classList.remove('menu-open');
            item.querySelector('.sub-menu-wrapper video')?.pause();
        }
    });
});

//# sourceMappingURL=hover-controls.js.map
